<template>
    <div class="fixed-column-table-wrapper">
        <div class="fixed-column-main">
            <div class="ranking-list-item me left" ref="fixedBody" v-if="myInfo" :class="[currentJobTab === '1' ? 'first' : '']">
                <div v-for="(column, index) in fixedColumns" :key="index" :style="{ width: column.width }" class="ranking-list-top">
                    <div class="ranking-num" v-if="index === 0" :style="{ width: column.width }">
                        <p>我</p>
                        <p class="color-red">{{ myInfo && myInfo[column.key] }}</p>
                    </div>

                    <div class="ranking-name" v-else-if="index === 1" :style="{ width: column.width }">
                        <van-image class="img" round :src="myInfo.avatar" error-icon="" />
                        <div class="ellipsis">
                            <div>{{ myInfo && myInfo.empName }}</div>
                            <div class="sectionName">{{ myInfo && myInfo.storeName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ranking-list-item me scrollable-body right" ref="scrollableTopBody" :class="[!myInfo ? 'scrollable-body-fixed' : '']">
                <div v-for="(column, index) in scrollableColumns" :key="index" :style="{ width: column.width }">
                    <div class="ranking-num" :style="{ width: column.width }">
                        <div v-if="myInfo">
                            {{ myInfo[column.key] }}
                            <span v-if="column.key === 'daChengRatio' || column.key === 'sameRatio'">%</span>
                            <span v-if="column.key === 'awardAmt'">元</span>
                            <span v-if="column.key === 'openOrderAmt' || column.key === 'netAmtMtd'">w</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-column-main fixed-column-table">

            <!-- 固定列容器 -->
            <div class="fixed-columns">
                <!-- 固定列内容 (包含表头和内容) -->
                <div class="fixed-body" ref="fixedBody">
                    <table>
                        <colgroup>
                            <col v-for="(column, index) in fixedColumns" :key="index" :style="{ width: column.width }" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th v-for="(column, index) in fixedColumns" :key="index + column.title">
                                    <div class="cell-content" :style="{ width: column.width }">
                                        {{ column.title }}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in data" :key="rowIndex">
                                <td v-for="(column, colIndex) in fixedColumns" :key="colIndex">
                                    <div class="cell-content ranking-num" v-if="colIndex === 0" :style="{ width: column.width }">

                                        <p v-if="row[column.key] > 3">{{ row[column.key] }}</p>
                                        <div v-else>
                                            <van-image class="img" round :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${row[column.key]}.png`" alt="" />
                                        </div>
                                    </div>
                                    <div class="cell-content ranking-name" v-else :style="{ width: column.width }">
                                        <van-image class="img" round :src="row.avatar" error-icon="" />
                                        <div class="ellipsis">
                                            <div>{{ row[column.key] }}</div>
                                            <div class="sectionName">{{ row.storeName }}</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- 可滚动列容器 -->
            <div class="scrollable-container" ref="scrollableContainer">
                <!-- 可滚动列内容 (包含表头和内容) -->
                <div class="scrollable-body" ref="scrollableBody">
                    <table>
                        <colgroup>
                            <col v-for="(column, index) in scrollableColumns" :key="index" :style="{ width: column.width }" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th v-for="(column, index) in scrollableColumns" :key="index + column.title">
                                    <div class="cell-content" :style="{ width: column.width }">
                                        {{ column.title }}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in data" :key="rowIndex">
                                <td v-for="(column, colIndex) in scrollableColumns" :key="colIndex">
                                    <div class="cell-content" :style="{ width: column.width }">
                                        <!-- <div v-if="row && row[column.key]"> -->
                                        <div v-if="row">
                                            {{ row[column.key] }}
                                            <span v-if="column.key === 'daChengRatio' || column.key === 'sameRatio'">%</span>
                                            <span v-if="column.key === 'awardAmt'">元</span>
                                            <span v-if="column.key === 'openOrderAmt' || column.key === 'netAmtMtd'">w</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { set } from 'lodash';

    export default {
        name: 'FixedColumnTable',
        props: {
            // 表格列配置
            columns: {
                type: Array,
                required: true
            },
            // 表格数据
            data: {
                type: Array,
                required: true
            },
            myInfo: {
                type: Object | null,
                required: true
            },
            myFlag: {
                type: Number | Boolean,
                required: 0
            },
            currentJobTab: {
                type: String,
                required: 0
            },
            currentGroupMillionTab: {
                type: String,
                required: 0
            },
            currentGroupTab: {
                type: String,
                required: 0
            }
        },
        computed: {
            // 固定列（前两列）
            fixedColumns() {
                return this.columns.slice(0, 2);
            },
            // 可滚动列（除前两列外的其他列）
            scrollableColumns() {
                return this.columns.slice(2);
            }
        },
        mounted() {
            // 监听滚动事件，实现固定列和滚动列的同步滚动
            this.$refs.scrollableBody.addEventListener('scroll', this.handleScroll);
            this.$refs.fixedBody.addEventListener('scroll', this.handleFixedScroll);
            this.$refs.scrollableTopBody.addEventListener('scroll', this.handleTopScroll);

        },
        beforeDestroy() {
            // 移除滚动事件监听
            if (this.$refs.scrollableBody) {
                this.$refs.scrollableBody.removeEventListener('scroll', this.handleScroll);
            }
            if (this.$refs.fixedBody) {
                this.$refs.fixedBody.removeEventListener('scroll', this.handleFixedScroll);
            }
            if (this.$refs.scrollableTopBody) {
                this.$refs.scrollableTopBody.removeEventListener('scroll', this.handleTopScroll);
            }
        },
        methods: {
            // 处理可滚动区域的滚动事件
            handleScroll(event) {
                const scrollTop = event.target.scrollTop;

                // 同步固定列区域的垂直滚动
                if (this.$refs.fixedBody) {
                    this.$refs.fixedBody.scrollTop = scrollTop;
                }

                if (this.$refs.scrollableTopBody) {
                    this.$refs.scrollableTopBody.scrollLeft = this.$refs.scrollableBody.scrollLeft
                }
            },
            handleTopScroll(event) {
                this.$refs.scrollableBody.scrollLeft = this.$refs.scrollableTopBody.scrollLeft
            },
            // 处理固定列区域的垂直滚动
            handleFixedScroll(event) {
                const scrollTop = event.target.scrollTop;

                // 同步可滚动区域的垂直滚动
                if (this.$refs.scrollableBody) {
                    this.$refs.scrollableBody.scrollTop = scrollTop;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .fixed-column-table-wrapper {
        width: 100%;
        overflow: hidden;
        border-radius: 4px;
    }

    .fixed-column-main {
        display: flex;
        justify-content: center;
        padding: 0 30px;
        width: 100%;
    }

    .fixed-column-table {
        padding: 0 30px;
        padding-top: 30px;
    }

    .fixed-columns {
        flex: 0 0 auto;
        background: #fff;
        position: relative;
        z-index: 2;
    }

    .fixed-columns::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: #eeeeee;
        transform: translateX(100%);
    }

    table {
        width: auto !important;
    }

    .fixed-body {}

    .scrollable-container {
        flex: 1;
        overflow: hidden;
    }

    .scrollable-body {
        overflow: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    th,
    td {
        padding: 0;
        text-align: center;

        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 60px;
        box-sizing: border-box;
        height: 46px;
    }

    th {
        font-size: 28px;
        color: #999999;
        font-weight: 400;
    }

    .fixed-body {
        th:nth-child(2) {
            .cell-content {
                justify-content: start;
            }
        }
    }

    td {
        border-bottom: 1px solid #EEEEEE;
        padding: 20px 0px;
    }


    tr:last-child td {
        border-bottom: none;
    }

    .cell-content {
        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        vertical-align: middle;
        height: 68px;
        justify-content: center;
        width: 80px;
        position: relative;

        img {
            width: 44px;
            position: absolute;
            right: 0;
            top: 4px;
        }
    }


    .ranking-num {
        width: 70px;
        text-align: center;
        margin-right: 40px;

        .img {
            width: 50px;
            height: 60px;
        }

        div {
            width: 100%;
        }

        p {
            margin: 0;
            text-align: center;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 220px;
        justify-content: inherit;

        .ellipsis {
            width: 220px;
            text-align: left;

            .sectionName {
                font-size: 22px;
                white-space: nowrap;
                /* 禁止换行 */
                overflow: hidden;
                /* 隐藏超出内容 */
                text-overflow: ellipsis;
                /* 显示省略号 */

            }
        }

        >.img {
            width: 60px;
            height: 60px;
            min-width: 60px;
            margin-right: 10px;
        }

    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        border-bottom: 2px solid #eeeeee;


        &.me {
            padding: 20px;
            margin-top: 30px;
            background: #FDE3D7;
            border-radius: 12px;
            border: none;
            padding-right: 0;

            .ranking-num {
                width: 70px;
                text-align: center;
                margin-right: 40px;

                div {
                    width: 100%;
                }
            }
        }

        .ranking-list-top:nth-child(1) {
            margin-right: 40px;
        }

        &.left {
            border-radius: 12px 0 0 12px;
        }

        &.right {
            border-radius: 0 12px 12px 0;
            padding: 20px 0;
        }

        &.meTwo {
            padding: 20px;
            margin-top: 30px;
            background: #FFF5E5;
            border-radius: 12px;
            border: none;

            .ranking-num {
                width: 70px;
                text-align: center;
                margin-right: 40px;

                div {
                    width: 100%;
                }
            }
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 70px;
            text-align: center;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            margin-right: 40px;

            .color-red {
                color: #AB080B;
            }

            .img {
                width: 50px;
                height: 60px;
            }

            p {
                margin: 0;
                text-align: center;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            flex: 2.5;


            .ellipsis {
                width: 220px;

                .sectionName {

                    white-space: nowrap;
                    /* 禁止换行 */
                    overflow: hidden;
                    /* 隐藏超出内容 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                }
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

        }

        .ranking-order {
            flex: 1.2;
            text-align: center;
        }

        .ranking-bonus {
            flex: 1.8;
            text-align: center;
        }


        .flagImg {
            width: 65px;
            height: 54px;
        }
    }

    .first {
        &.me {
            background: #FDE3D7;
        }
    }

    .scrollable-body-fixed {
        display: none;
    }

    /* 滚动条样式 */
    .fixed-body::-webkit-scrollbar,
    .scrollable-body::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }

    .fixed-body::-webkit-scrollbar-thumb,
    .scrollable-body::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
    }

    .fixed-body::-webkit-scrollbar-track,
    .scrollable-body::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }

    /* 隐藏固定列的水平滚动条 */
    .fixed-body::-webkit-scrollbar:horizontal {
        display: none;
    }
</style>